<template>
    <div id="loading" :class="{ triggered: trigger }">
        <div class="container">
            <div class="loader"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        trigger: {
            type: Boolean,
        },
        message: {
            type: String,
            default: "Please wait",
        },
    },
};
</script>
<style lang="scss" scoped>
#loading {
    transition: 0.4s linear;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    background-color: white;
    height: 100%;
    width: 100%;
    z-index: -1;
    opacity: 0;

    &.triggered {
        z-index: 200 !important;
        opacity: 1 !important;
    }

    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        z-index: 9999;
        @media screen and (max-width: 400px) {
            flex-direction: column;
        }
    }

    .loader {
        width: 40px;
        height: 40px;
        border: 3px solid;
        background-color: transparent;
        border-radius: 50%;
        color: #f3f6f6;
        border-top-color: transparent;
        animation: loader 1.2s linear infinite;
        -webkit-animation: loader 1.2s linear infinite;
    }

    @keyframes loader {
        to {
            transform: rotate(360deg);
        }
        33% {
            color: #90eee1;
        }
        66% {
            color: #6356e5;
        }
    }

    @-webkit-keyframes loader {
        to {
            transform: rotate(360deg);
        }
        33% {
            color: #90eee1;
        }
        66% {
            color: #6356e5;
        }
    }
}
</style>
